module.exports = __webpack_public_path__ + "static/media/mayank_jain.b75e6157.jpg";